import { render, staticRenderFns } from "./WorkspaceListsTab.vue?vue&type=template&id=4aab0442&"
import script from "./WorkspaceListsTab.vue?vue&type=script&lang=js&"
export * from "./WorkspaceListsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports